<template>
  <div class="b-filters-wrap">
    <div class="b-filters"></div>
    <div v-if="educationLevel" class="b-filters">
      <div class="b-filters">
        <div class="b-filters__title">
          {{ educationFilterTitle }}
        </div>
        <div class="b-filters__holder">
          <EducationCheckboxes
            :model-value="currentSelection['educationLevel']"
            :all-education-level="allEducationLevel"
            :all-filters="filters['educationLevel']"
            :filtered="filters['educationLevel']"
            @filter-changed="updateSelectedFilters"></EducationCheckboxes>
        </div>
      </div>
    </div>
    <div v-if="!educationLevel" class="b-filters">
      <div class="b-filters">
        <div class="b-filters__title">
          {{ genreFilterTitle }}
        </div>
        <div class="b-filters__holder">
          <GenresCheckboxes
            :model-value="currentSelection['genres']"
            :all-genres="allGenres"
            :all-filters="filters['genres']"
            :filtered="filters['genres']"
            @filter-changed="updateSelectedFilters"></GenresCheckboxes>
        </div>
      </div>
    </div>
    <button
      type="button"
      class="btn-cta b-filters__clear-all"
      @click="toClearFilters">
      {{ clearFilters }}
    </button>
  </div>
</template>

<script>
import EducationCheckboxes from './EducationCheckboxes.vue'
import GenresCheckboxes from './GenresCheckboxes.vue'
import { getLocale } from '../../lib/lib'

export default {
  components: {
    EducationCheckboxes,
    GenresCheckboxes,
  },
  props: {
    educationFilterTitle: {
      default: 'Education',
      type: String,
    },
    genreFilterTitle: {
      default: 'Genre',
      type: String,
    },
    clearFilters: {
      default: 'Clear filters',
      type: String,
    },
    allGenres: {
      default: 'All genres',
      type: String,
    },
    allEducationLevel: {
      default: 'All education level',
      type: String,
    },
    filters: {
      default() {
        return {}
      },
      type: Object,
    },
    selectedFilters: {
      default() {
        return {}
      },
      type: Object,
    },
    showFilters: {
      default() {
        return []
      },
      type: Array,
    },
    placeholders: {
      default() {
        return []
      },
      type: Array,
    },
    hasDates: {
      default: true,
      type: Boolean,
    },
    educationLevel: {
      default: true,
      type: Boolean,
    },
  },
  emits: ['filterChanged', 'resetFilters'],

  data() {
    return {
      currentSelection: { ...this.selectedFilters },
      locale: getLocale(),
    }
  },
  computed: {
    modelValue() {
      return this.selectedFilters.dates?.length > 0
        ? this.selectedFilters.dates
        : ''
    },

    filtersHaveValues() {
      return (
        this.filters[this.showFilters[0]]?.length > 0 ||
        this.filters[this.showFilters[1]]?.length > 0 ||
        this.filters[this.showFilters[2]]?.length > 0
      )
    },
  },
  watch: {
    selectedFilters: {
      handler(newVal) {
        this.currentSelection = { ...newVal }
      },
    },
  },
  created() {
    if (this.hasDates) {
      this.updateSelectedFilters(this.selectedFilters.dates, 'dates', false)
    }
  },

  mounted() {
    this.setFiltersByParams()
  },

  methods: {
    setFiltersByParams() {
      const rawParams = new URLSearchParams(window.location.search)
      const params = {}
      for (const [key, value] of rawParams.entries()) {
        params[key.toLowerCase()] = value.toLowerCase()
      }

      const screenTypeParam = params['screentype']

      if (screenTypeParam) {
        const selected = this.filtersDataFiltered.roomTypes.find(
          (item) => item.display.toLowerCase() === screenTypeParam
        )

        if (selected) {
          this.currentSelection.roomTypes = selected.value
        }
      }
    },

    toClearFilters() {
      this.$emit('resetFilters')
    },

    updateSelectedFilters(filters, key, scroll = true) {
      for (const k in filters) {
        if (k !== 'genres' && k !== 'dates' && k !== 'educationLevel') {
          this.currentSelection[key] = filters[key]
        }
      }
      if (key === 'genres') {
        this.currentSelection['genres'] = [...filters]
      }
      if (key === 'educationLevel') {
        this.currentSelection['educationLevel'] = [...filters]
      }
      if (key === 'dates') {
        this.currentSelection['dates'] = filters
      }

      this.$emit('filterChanged', this.currentSelection, scroll)
    },
  },
}
</script>
